// ADD 2023.04.13 会員登録後遷移先出しわけ　@ci-inada START
class CustomerRegister {
	PATH = location.pathname;
	constructor() {
		// Click Register btn in Cart page
		if (this.PATH.includes('/cart')) {
			window.addEventListener('DOMContentLoaded', () => {
				const register = document.querySelector('.btn.register-btn[href*="/account/register"]');
				if (register !== null) {
					register.addEventListener('click', e => {
						e.preventDefault();
						localStorage.setItem('pigeon-referrer', '/cart');
						location.href = register.href;
					});
				}
				return;
			});
		}

		// Success registered
		if (this.PATH === '/account') {
			const referrer = localStorage.getItem('pigeon-referrer');
			if (referrer !== null) {
				localStorage.removeItem('pigeon-referrer');
				location.href = referrer;
				return;
			}
		}

		// Skip register page & reCAPTCHA page 
		if (this.PATH.includes('/challenge') || this.PATH.includes('/account/register')) {
			return;
		}

		// If other pages, Destroy Referrer 
		localStorage.removeItem('pigeon-referrer');
	}
};
new CustomerRegister;
//ADD 2023.04.13 会員登録後遷移先出しわけ　@ci-inada END

// UPDATE 2023.08.02 @ci-goto SHP_PIGEON-138 商品ページからの遷移先変更・追加 START
class NotTransitionProductForm {
	constructor(form) {
		this.form = form;

		const submit = this.form.querySelector('[data-add-to-cart]');
		this.form.addEventListener('submit', async e => {
			e.preventDefault();
			await this.submitAction(submit);
		});


		const button = this.form.querySelector('[data-add-to-cart-sub]');
		button.addEventListener('click', async () => {
			if (await this.submitAction(button) === true) {
				location.href = '/cart';
			}
		});
	};

	showLimit(btn) {
		this.form.querySelector('.limit-notice').classList.remove('hide');
		btn.disabled = true;
	};

	async submitAction(btn) {
		btn.classList.add('btn--loading');


		try {
			const formdate = new FormData(this.form);
			const id = formdate.get('id');
			const qty = formdate.get('quantity');

			const { items } = await (await fetch('/cart.js')).json();
			const item = items.filter(({ variant_id }) => variant_id == id)[0];

			if (item !== undefined && +qty + item.quantity > this.form.limit) {
				alert('購入数の上限に達しています。');
				this.showLimit(btn);
				btn.classList.remove('btn--loading');
				return;
			}

			const res = await (await fetch('/cart/add.js', { method: 'post', header: {}, body: formdate })).json();
			console.log(res)
			alert('商品をカートに追加出来ました。');

			if (res.quantity >= this.form.limit) {
				this.showLimit(btn);
			}

			return true;
		} catch (err) {
			console.log(err);
			alert('商品をカートに追加出来ませんでした。');
			return false;
		} finally {
			btn.classList.remove('btn--loading');
		}
	};
};
// UPDATE 2023.08.02 @ci-goto SHP_PIGEON-138 商品ページからの遷移先変更・追加 END
